import React from "react";
import Link from "next/link";
import { Col } from "reactstrap";
import { useRouter } from "next/navigation";
import useAppDispatch from "@/app/hooks/useAppDispatch";
import { toggleComposeModal } from "@/store/commCenterSlice";

interface InformationSectionProps {
  user: any;
}

const InformationSection: React.FC<InformationSectionProps> = ({ user }) => {
  const router = useRouter();
  const dispatch = useAppDispatch();

  const handleMessageClick = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(toggleComposeModal());
    router.push("/secure/communication-center/inbox/messages");
  };

  return (
    <Col md="6">
      <p className="text-[16px]">
        If you have questions or have feedback regarding UnitedHealth
        Premium, please{" "}
        {user?.id ? (
          <Link
            href="/secure/communication-center/inbox/messages"
            className="!text-[#196ecf] !font-semibold !hover:underline"
            style={{ fontSize: "16px" }}
            onClick={handleMessageClick}
          >
            send us a message
          </Link>
        ) : (
          "complete this form"
        )}
        {"."}
      </p>
      <p className="text-[16px]">
        We evaluate all feedback for potential incorporation into our
        program.
      </p>
      {/*<p className="text-[16px]">
        Link to an
        <Link
          href="/help/faq/general-premium-program-questions"
          className="!text-[#196ecf] !font-semibold !hover:underline"
        >
          {" "}
          FAQ{" "}
        </Link>
        for assistance with:
      </p>
      <ul className="!list-disc">
        <li className="text-[16px]">
          Updating a physician's
          <Link
            href="/help/faq/updating-my-profile-information"
            className="!text-[#196ecf] !font-semibold !hover:underline"
          >
            {" "}
            Premium specialty or primary place of service{" "}
          </Link>
        </li>
        <li className="text-[16px]">
          Removing, adding, or changing a physician's
          <Link
            href="/help/faq/updating-my-profile-information"
            className="!text-[#196ecf] !font-semibold !hover:underline"
          >
            {" "}
            group affiliation{" "}
          </Link>
        </li>
      </ul>
      {!user ? (
        <>
          <p className="text-[16px]">
            If you need help signing in, please visit the
            <Link
              href="/help/faq/website-navigation"
              className="!text-[#196ecf] !font-semibold !hover:underline"
            >
              {" "}
              Website Navigation{" "}
            </Link>
            section of the FAQs under Help and Support.
          </p>*/}
      {!user ? (
        <>
          <p className="text-[16px]">
            If you need assistance with your One Healthcare ID, please click 'Sign‑in' and use the 'Chat with support' for assistance.
          </p>
          <p>
            Premium does not have access to tier status information. For any questions related to tier status, a chat advocate is available 24/7.
            Please <Link
            href="https://www.uhcprovider.com/en/contact-us.html"
            className="!text-[#196ecf] !font-semibold !hover:underline"
          >
            {" "}
            sign in{" "}
          </Link>
            to UHCprovider.com with your One Healthcare ID. Then, select the chat icon at the bottom-right corner of the page.
          </p>
        </>
      ) : (
        <p className="text-[16px]">
          If you need help navigating this site use one of our{" "}
          <Link
            className="!text-[#196ecf] !font-semibold !hover:underline"
            href="/help/premium-training"
          >
            Quick Reference Guides
          </Link>
          .
        </p>
      )}
    </Col>
  );
};

export default InformationSection;
